import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { MotionConfig } from 'framer-motion'
import { LandingPage } from './components/LandingPage'
import { CookieConsent } from './components/CookieConsent'
import { TermosDeUso } from './pages/TermosDeUso'
import { Privacidade } from './pages/Privacidade'
import { LGPD } from './pages/LGPD'
import { Cookies } from './pages/Cookies'
import { Sobre } from './pages/Sobre'
import { Contato } from './pages/Contato'
import { ExclusaoDeDados } from './pages/ExclusaoDeDados'

export default function App() {
  return (
    <MotionConfig reducedMotion="user">
      <BrowserRouter>
        <div className="w-full min-h-screen">
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/termos-de-uso" element={<TermosDeUso />} />
            <Route path="/privacidade" element={<Privacidade />} />
            <Route path="/lgpd" element={<LGPD />} />
            <Route path="/exclusao-de-dados" element={<ExclusaoDeDados />} />
            <Route path="/cookies" element={<Cookies />} />
            <Route path="/sobre" element={<Sobre />} />
            <Route path="/contato" element={<Contato />} />
          </Routes>
          <CookieConsent />
        </div>
      </BrowserRouter>
    </MotionConfig>
  )
}
